import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginNavigationBar from "@/layout/LoginNavigationBar";
import NavigationBar from "@/layout/NavigationBar";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        redirect: "/login",
        hidden: true
    },
    {
        path: "/login",
        component: LoginNavigationBar,
        children: [
            {
                name: "Login",
                path: "/",
                component: () => import("@/views/login/index"),
                meta: { title: "ログイン", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/admin/login",
        component: LoginNavigationBar,
        children: [
            {
                name: "AdminLogin",
                path: "/",
                component: () => import("@/views/login/index"),
                meta: { title: "ログイン", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/admin/users",
        component: NavigationBar,
        children: [
            {
                name: "Users",
                path: "/",
                component: () => import("@/views/admin/user/index"),
                meta: { title: "ユーザー一覧", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/admin/newuser",
        component: NavigationBar,
        children: [
            {
                name: "NewUser",
                path: "/",
                component: () => import("@/views/admin/user/new"),
                meta: { title: "ユーザー新規登録", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/admin/users/edit",
        component: NavigationBar,
        children: [
            {
                name: "EditUser",
                path: ":id(\\d+)",
                component: () => import("@/views/admin/user/edit"),
                meta: { title: "ユーザー編集", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/user/certificate",
        component: NavigationBar,
        children: [
            {
                name: "Certificate",
                path: "/",
                component: () => import("@/views/user/certificate/index"),
                meta: { title: "申請一覧", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/user/new/certificate",
        component: NavigationBar,
        children: [
            {
                name: "NewCertificate",
                path: "/",
                component: () => import("@/views/user/certificate/new"),
                meta: { title: "新規申請フォーム", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/user/certificate/edit",
        component: NavigationBar,
        children: [
            {
                name: "EditCertificate",
                path: ":id(\\d+)",
                component: () => import("@/views/user/certificate/edit"),
                meta: { title: "申請詳細", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/",
        component: LoginNavigationBar,
        children: [
            {
                path: "/400",
                component: () => import("@/views/error/400"),
                name: "400",
                meta: { title: "400", icon: "mdi-home" }
            },
            {
                path: "/admin/400",
                component: () => import("@/views/error/400"),
                name: "admin400",
                meta: { title: "400", icon: "mdi-home" }
            }
        ]
    },
    {
        path: "/",
        component: LoginNavigationBar,
        children: [
            {
                path: "/401",
                component: () => import("@/views/error/401"),
                name: "401",
                meta: { title: "401", icon: "mdi-home" }
            },
            {
                path: "/admin/401",
                component: () => import("@/views/error/401"),
                name: "admin401",
                meta: { title: "401", icon: "mdi-home" }
            }
        ]
    },
    {
        path: "/",
        component: LoginNavigationBar,
        children: [
            {
                path: "/403",
                component: () => import("@/views/error/403"),
                name: "403",
                meta: { title: "403", icon: "mdi-home" }
            },
            {
                path: "/admin/403",
                component: () => import("@/views/error/403"),
                name: "admin403",
                meta: { title: "403", icon: "mdi-home" }
            }
        ]
    },
    // 500エラー
    {
        path: "/",
        component: LoginNavigationBar,
        children: [
            {
                path: "500",
                name: "SaverError",
                component: () => import("@/views/error/500"),
                meta: { title: "500", icon: "mdi-home" }
            },
            {
                path: "/admin/500",
                name: "AdminSaverError",
                component: () => import("@/views/error/500"),
                meta: { title: "500", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "/",
        component: LoginNavigationBar,
        children: [
            {
                path: "/503",
                name: "503",
                component: () => import("@/views/error/503"),
                meta: { title: "503", icon: "mdi-home" }
            },
            {
                path: "/admin/503",
                name: "admin503",
                component: () => import("@/views/error/503"),
                meta: { title: "503", icon: "mdi-home" }
            }
        ],
        hidden: true
    },
    {
        path: "*",
        component: LoginNavigationBar,
        children: [
            {
                path: "*",
                component: () => import("@/views/error/404"),
                name: "404",
                meta: { title: "404", icon: "mdi-home" }
            },
            {
                path: "/admin/*",
                component: () => import("@/views/error/404"),
                name: "admin404",
                meta: { title: "404", icon: "mdi-home" }
            }
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    store.commit("SET_LOADING", false);
    next();
});

export default router
